<button mat-menu-item [disabled]="statsMode === StatsMode.SELECTIVE" (click)="changeStatsMode(StatsMode.SELECTIVE)">
  <i class="ri-discount-percent-line stats-setting"></i>
  <span>{{ 'button.selective_exclusion_percentage' | translate }}</span>
</button>
<button mat-menu-item [disabled]="statsMode === StatsMode.COMPLETE" (click)="changeStatsMode(StatsMode.COMPLETE)">
  <i class="ri-water-percent-line stats-setting"></i>
  <span>{{ 'button.full_exclusion_percentage' | translate }}</span>
</button>
